import { render, staticRenderFns } from "./BrazilVCard.vue?vue&type=template&id=db9a52e8&scoped=true&"
import script from "./BrazilVCard.vue?vue&type=script&lang=js&"
export * from "./BrazilVCard.vue?vue&type=script&lang=js&"
import style0 from "./BrazilVCard.vue?vue&type=style&index=0&id=db9a52e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9a52e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
